import { render, staticRenderFns } from "./SortClockDescendingOutline.vue?vue&type=template&id=1ed7ca2a"
import script from "./SortClockDescendingOutline.vue?vue&type=script&lang=js"
export * from "./SortClockDescendingOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports